import { css } from '@emotion/css';
import { amount } from 'Shared/frontend/widgets/Amount';
import { Component } from 'Shared/frontend/widgets/Component';
import { calcHeight } from 'Shared/frontend/widgets/HeightUtils';
import { theme } from 'Shared/frontend/SettingsProvider';
import { ChildKeyContext } from 'Shared/frontend/widgets/StylesProvider';


export function Overlay(P)
{
	const foregroundStyle = (height) => css({
		position: 'absolute',
		width: amount(P.width),
		...calcHeight(height)
	});

	const overlayStyle = (height) => css(theme().widgets.overlay,{
		position: 'relative',
//		overflow: 'hidden',
		height: height.parent ? '100%' : 'fit-content',

		'& > *:first-child': {
			width: '100%',
			...calcHeight(height)
		}
	});

	const addAxis = (data,axis:'X'|'Y',settings,transformations) => {
		const offset = (data.side=='center' ? '50%' : amount(data.offset)) ?? 0;

		settings[data.side=='center' ? (axis=='X' ? 'left' : 'top') : data.side] = offset;

		if (offset.endsWith?.('%')) 
			transformations.push(`translate${axis}(-${offset})`);
	};

	const alignmentStyle = () => {
		const settings = {};
		const transformations = [];

		addAxis(P.vertical,'Y',settings,transformations);
		addAxis(P.horizontal,'X',settings,transformations);

		if (transformations.length > 0)
			settings.transform = transformations.join(' ');

		return settings;
	};

	return (
		<div class={css(overlayStyle(P.height), P.styling.css ?? {})}>
			<ChildKeyContext.Provider value={() => 'background'}>
				<Component {...P.background} />
			</ChildKeyContext.Provider>

			<div class={css(foregroundStyle(P.foregroundHeight ?? {child:true}),alignmentStyle())}>
				<ChildKeyContext.Provider value={() => 'foreground'}>
					<Component {...P.foreground} />
				</ChildKeyContext.Provider>
			</div>
		</div>
	);
}

